<template>
    <b-row no-gutters class="login-row">
        <b-col align-self="center" class="px-2 text-center">
            <br>
            <img :src="logo" alt="logo-moregiros" class="logo-small">
            <b-form id="formLogin" @submit.stop.prevent="submit" class="form-signin mt-4 mb-2">
                <b-form-group>
                    <b-form-input
                        id="email"
                        name="email"
                        type="email"
                        v-model="form.email"
                        class="text-center"
                        :placeholder="labels.email"
                        v-validate="'required:true|email'"
                        :state="validateState('email')"
                        aria-describedby="email-live-feedback"
                        :data-vv-as="(labels.email).toLowerCase()"
                        :disabled="loading"
                        size="lg"
                        autofocus/>
                    <b-form-invalid-feedback id="email-live-feedback">{{ veeErrors.first('email') }}</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group >
                    <b-input-group>
                        <b-form-input
                            id="password"
                            name="password"
                            :type="passwordHidden ? 'password' : 'text'"
                            v-model="form.password"
                            class="text-center"
                            :placeholder="labels.password"
                            v-validate="{ required: true, min: 8 }"
                            :state="validateState('password')"
                            aria-describedby="password-live-feedback"
                            :data-vv-as="(labels.password).toLowerCase()"
                            :disabled="loading"
                            size="lg"/>
                        <b-input-group-append>
                            <b-button variant="outline-default" @click="passwordHidden = !passwordHidden" class="m-0 btlr-0 bblr-0">
                                <i class="material-icons">{{ passwordHidden ? 'visibility_off' : 'visibility' }}</i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback id="password-live-feedback">{{ veeErrors.first('password') }}</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group hidden class="my-4 text-left">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="rememberme" checked>
                        <label class="custom-control-label" for="rememberme">{{labels.remember}}</label>
                    </div>
                </b-form-group>

                <b-link :to="form.email ? {name: 'Forgot', query: {email: form.email}} : {name: 'Forgot'}" :disabled="loading"
                    class="mt-4 d-block">
                    <i class="mdi mdi-lock-reset v-align-baseline"></i>
                    <span>{{labels.recovery}}</span>
                </b-link>
            </b-form>
        </b-col>

        <!-- login buttons -->
        <b-row class="mx-0 bottom-button-container">
            <b-col>
                <b-button type="submit" variant="default" size="lg" pill block class="shadow"
                          form="formLogin" :disabled="loading">
                    <b-spinner small type="grow" v-if="loading"></b-spinner>
                    <b-icon icon="box-arrow-in-right" aria-hidden="true" v-else></b-icon>
                    <span class="v-align-baseline">{{ loading ? labels.load : labels.login }}</span>
                </b-button>
            </b-col>
        </b-row>
        <!-- login buttons -->
    </b-row>
</template>

<script>
import axios from 'axios';

export default {
        name: 'Login',
        data: () => ({
            logo: '/img/logo_login.png',
            passwordHidden: true,
            labels: {
                email: 'Correo Electrónico',
                password: 'Contraseña',
                remember: 'Recordarme',
                recovery: '¿Olvidaste tu contraseña?',
                load: 'Iniciando Sesión...',
                login: 'Iniciar Sesión'
            },
            form: {
                email: null,
                password: null
            },
            loading: false,
            path: null
        }),
        created() {
            this.form.email = this.$route.query.email || null;
            this.path = this.$route.query.to || null;
        },
        mounted() {
            this.loginRow();
            window.addEventListener("resize", this.loginRow);
            this.$emit('loader');
        },
        methods: {
            loginRow() {
                $('.login-row').css('min-height', ($(window).height() - 80));
            },
            validateState(ref) {
                if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm() {
                this.form = {
                    email: null,
                    password: null
                };

                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            submit() {
                this.$validator.validateAll().then(result => {
                    if (!result) { return; }
                    this.loading = true;
                    axios.post('/api/login', this.form).then(res => {
                        this.$root.$bvToast.toast('¡Bienvenido a MoreGiros!', {
                            title: 'Felicitaciones',
                            headerClass: 'd-none',
                            variant: 'success',
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 5000,
                            solid: true,
                            appendToast: true
                        });
                        this.success(res.data);
                    }).catch(err => {
                        this.loading = false;
                    });
                });
            },
            success(data) {
                this.$store.dispatch('saveToken', data);
                this.$store.dispatch('setUser', data);
                if (this.path) {
                    this.$router.push({ path: this.path });
                } else {
                    if (data.user.role !== 'Customer') {
                        if(data.user.role === 'Partner' || data.user.role === 'Cashier') {
                            this.$router.push({ name: "PartnerHome" });
                        } else {
                            this.$router.push({ name: "AdminHome" });
                        }
                    } else {
                        this.$router.push({ name: "Home" });
                    }
                }
            }
        }
    }
</script>
